module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_link_image_item-bee058db94ba4d11705cd816c247abb3.jpg";